import request from '@/api/request.js'

/**
 * 可被多个音效复用的版权档案接口。
 */
const apis = {
  /**
   * 获取档案类型、使用方式和权利范围选项。
   *
   * @returns {Promise}
   */
  options() {
    return request({ url: '/admin_sound_rights_record/options', method: 'GET' })
  },

  /**
   * 分页读取共享版权档案。
   *
   * @param {Object} params 筛选和分页参数
   * @returns {Promise}
   */
  lists(params = {}) {
    return request({ url: '/admin_sound_rights_record/lists', method: 'GET', params })
  },

  /**
   * 为音效编辑器远程搜索可关联档案。
   *
   * @param {Object} params 包含 keyword
   * @returns {Promise}
   */
  search(params = {}) {
    return request({ url: '/admin_sound_rights_record/search', method: 'GET', params })
  },

  /**
   * 读取单个版权档案及证明文件。
   *
   * @param {Object} params 包含 record_id
   * @returns {Promise}
   */
  read(params) {
    return request({ url: '/admin_sound_rights_record/read', method: 'GET', params })
  },

  /**
   * 新建或修改共享版权档案。
   *
   * @param {Object} params 包含 record_id、record 和 change_reason
   * @returns {Promise}
   */
  save(params) {
    return request({ url: '/admin_sound_rights_record/save', method: 'POST', data: params })
  },

  /**
   * 上传并关联证明文件。
   *
   * @param {FormData} formData 包含 record_id 和 evidence_file
   * @returns {Promise}
   */
  uploadEvidence(formData) {
    return request({
      url: '/admin_sound_rights_record/uploadEvidence',
      method: 'POST',
      data: formData
    })
  },

  /**
   * 鉴权下载共享档案证明文件。
   *
   * @param {Object} params 包含 record_id 和 evidence_id
   * @returns {Promise}
   */
  downloadEvidence(params) {
    return request({
      url: '/admin_sound_rights_record/downloadEvidence',
      method: 'GET',
      params,
      responseType: 'blob'
    })
  },

  /**
   * 从当前档案解除证明文件。
   *
   * @param {Object} params 包含 record_id 和 evidence_id
   * @returns {Promise}
   */
  removeEvidence(params) {
    return request({
      url: '/admin_sound_rights_record/removeEvidence',
      method: 'POST',
      data: params
    })
  }
}

export default apis
